import { deliveryInstructionApis } from '@apis/deliveryInstructionApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useDeliveryInstruction = createUseQuery(
  (d2d_no: string) => ['/delivery-instruction/', d2d_no],
  (d2d_no) => () =>
    deliveryInstructionApis
      .get('/delivery-instruction/{d2d_no}/', {
        path: { d2d_no },
      })
      .then((r) => {
        if (r[404]) {
          return null;
        }
        return r[200];
      }),
);
